import React from 'react';
import { Card, CardContent } from '../ui/card';
import { CheckCircle, XCircle, Award, Shield } from 'lucide-react';

const WhoCanApplySection = () => {
  return (
    <section id="who-can-apply" className="py-24 bg-[#020817]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">Single Custody Collateral</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-4">
              We work exclusively with verified and licensed partners.
            </p>
            <p className="text-base text-white/70 leading-relaxed">
              Every producer or mandate we onboard goes through full KYB verification, license validation, and compliance review before any transaction can occur — protecting both sides of the trade.
            </p>
          </div>
          <div className="relative">
            <div className="absolute -top-4 -right-4 w-28 h-28 bg-[#D4AF37]/25 rounded-2xl"></div>
            <img
              src="https://images.unsplash.com/photo-1709489662983-3674d790b224?w=1400&q=80&auto=format&fit=crop"
              alt="Licensed mining operations on dirt road"
              className="relative z-10 w-full h-[380px] object-cover rounded-3xl shadow-2xl"
            />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Accepted */}
          <Card className="border-2 border-green-200 bg-[#0B132B]/60 shadow-lg">
            <CardContent className="p-8">
              <div className="flex items-center justify-center mb-6">
                <CheckCircle className="h-10 w-10 text-green-500 mr-3" />
                <h3 className="text-2xl font-bold text-green-700">We Accept</h3>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-center p-3 bg-green-50 rounded-lg border border-green-200">
                  <Award className="h-6 w-6 text-green-600 mr-3 flex-shrink-0" />
                  <div>
                    <h4 className="font-bold text-green-800">Licensed Gold Producers</h4>
                  </div>
                </div>
                
                <div className="flex items-center p-3 bg-green-50 rounded-lg border border-green-200">
                  <Shield className="h-6 w-6 text-green-600 mr-3 flex-shrink-0" />
                  <div>
                    <h4 className="font-bold text-green-800">Official Mandates</h4>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Not Accepted */}
          <Card className="border-2 border-red-200 bg-[#0B132B]/60 shadow-lg">
            <CardContent className="p-8">
              <div className="flex items-center justify-center mb-6">
                <XCircle className="h-10 w-10 text-red-500 mr-3" />
                <h3 className="text-2xl font-bold text-red-700">We Don't Accept</h3>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center p-3 bg-red-50 rounded-lg border border-red-200">
                  <XCircle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0" />
                  <span className="text-red-700 font-medium">Brokers</span>
                </div>
                <div className="flex items-center p-3 bg-red-50 rounded-lg border border-red-200">
                  <XCircle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0" />
                  <span className="text-red-700 font-medium">Unlicensed operators</span>
                </div>
                <div className="flex items-center p-3 bg-red-50 rounded-lg border border-red-200">
                  <XCircle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0" />
                  <span className="text-red-700 font-medium">Mediators</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default WhoCanApplySection;